import { Card, Box, Stack, Typography } from "@mui/material";

export default function NotAvailable() {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                boxSizing: "border-box",
                height: "calc(100vh - var(--header-height))",
                p: 2,
            }}
            data-test-id="section_not_available"
        >
            <Card sx={{ width: "100%", maxWidth: 600, boxSizing: "border-box" }}>
                <Stack spacing={2} sx={{ width: "100%", padding: 2, alignItems: "center" }}>
                    <img src="/images/out-of-buzz.svg" alt="out of buzz" width="80" height="80" />
                    <Typography variant="h6" textAlign="center" sx={{ overflowWrap: "break-word" }}>
                        Sorry, it looks like the online portal functionality is not available for this practice.
                    </Typography>
                    <Typography variant="caption" textAlign="center" sx={{ overflowWrap: "break-word" }}>
                        Please contact them directly to make an appointment.
                    </Typography>
                </Stack>
            </Card>
        </Box>
    );
}
